import { render, staticRenderFns } from "./privacyAndPolicyTemplate.vue?vue&type=template&id=cc48d72e"
import script from "./privacyAndPolicyTemplate.vue?vue&type=script&lang=js"
export * from "./privacyAndPolicyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports